module.exports = __webpack_public_path__ + "static/media/buy_report_service_5.4cea3e02.png";